import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colSpan: {
          "0:0": 2,
        },
        rowsSize: [2, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/03/principle/soft-absorbing-wall-image.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    formatter: "html",
                    scrollbars: false,
                    data:
                      "<b>Description</b></br></br>There is a sound absorbing wall near the sound source and the listener. One additional reflection (in blue) can be seen in the graph besides the direct sound (in red), but with a lower amplitude compared to the reflection from a hard wall. The comb filter effect (change in timbre) is less pronounced compared to the case with a hard reflecting wall.",
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/03/principle/soft-absorbing-wall-chart.svg`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/05/03/principle/soft-absorbing-wall-voice.wav`,
      text: "Voice",
      icon: "cil-volume",
      shape: "round",
    },
  },
  {
    type: "audioButton",
    options: {
      theme: "primary",
      url: `${config.ASSETS_URL}/05/03/principle/soft-absorbing-wall-drums.wav`,
      text: "Drums",
      icon: "cil-volume",
      shape: "round",
    },
  },
];
